// extracted by mini-css-extract-plugin
export default {"logo":"footer_logo__PpWb2","submit":"footer_submit__Zp305","light":"footer_light__ZkLwt","social":"footer_social__dPObY","input":"footer_input__pvzNA"};